module.exports = __webpack_public_path__ + "img/icon-score.0fd2b96d.png";